import * as style from "../../../../src/content/blog-posts/alternatives-to-rover-2026/style.module.scss";
import * as React from 'react';
export default {
  style,
  React
};